import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import Toolbar from '@mui/material/Toolbar';
import Drawer from '@mui/material/Drawer';
import Link from '@mui/material/Link';
import { DocMetaData } from 'src/docs/types';
import { useDocsContext } from './DocsContext';

export const tocWidth = 240;

interface Props {
  meta: DocMetaData;
}

export default function TOC({ meta }: Props): React.ReactElement {
  const theme = useTheme();
  const { activeIds } = useDocsContext();

  if (!meta.headings) {
    return <></>;
  }

  return (
    <Drawer
      variant="permanent"
      anchor="right"
      ModalProps={{
        keepMounted: true, // Better open performance on mobile.
      }}
      PaperProps={{
        sx: {
          pt: 1,
          width: tocWidth,
          [theme.breakpoints.down('md')]: {
            display: 'none',
          },
        },
      }}
    >
      <Toolbar />
      {meta.headings.map((h, index) => {
        if (h.title) {
          const active = activeIds.includes(h.slug);
          return (
            <Link
              key={index}
              sx={{
                p: 1,
                color: active ? theme.palette.text.primary : theme.palette.text.secondary,
                backgroundColor: active ? theme.palette.action.hover : undefined,
                pl: h.depth,
                '&:hover': {
                  backgroundColor: theme.palette.action.hover,
                },
              }}
              href={`#${h.slug}`}
            >
              {h.title}
            </Link>
          );
        }
      })}
    </Drawer>
  );
}
